import { NgModule } from '@angular/core';
import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';

import { RenderEvoModule } from '@slidebean/render';
import {
  Location,
  LocationStrategy,
  PathLocationStrategy,
} from '@angular/common';
import {
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}
import { SpinnerModule } from '@slidebean/ui/spinner';
import { PusherModule } from '@slidebean/pusher';
import { ApolloProvider, ApolloModule } from './graphql';
import {
  RenderPluginsModule,
  SLIDE_HEIGHT,
  SLIDE_WIDTH,
} from './render/render-plugins.module';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    ApolloModule,
    BrowserModule,
    HammerModule,
    RenderPluginsModule,
    RenderEvoModule.forRoot({
      slideHeight: SLIDE_HEIGHT,
      slideWidth: SLIDE_WIDTH,
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    SpinnerModule,
    PusherModule.forRoot({
      key: '',
      authEndpoint: '',
    }),
  ],
  providers: [
    Location,
    ApolloProvider,
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
